import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F3F4F6]">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-[#1B365D] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-[#1B365D] font-medium">Chargement...</p>
                </div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (adminOnly && user.role !== 'admin') {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}
